import { createClient } from "@supabase/supabase-js";

// --- Initialize Supabase ---
const supabase = createClient(
  "https://nxsuekxfqsoqnshzowre.supabase.co",
  "sb_publishable_lwe94Jr6nTuCGhAlJOmVDw_9M9azFGI"
);

// --- Submit Score ---
export async function submitScore(player_name, player_score) {
  try {
    const { data, error } = await supabase.functions.invoke("submit-score", {
      body: JSON.stringify({player_name, player_score }),
      headers: { "x-submit-secret": "SHARED_SECRET" },
    });

    if (error) throw error;
    return data;
  } catch (err) {
    console.error("❌ Error submitting score:", err.message);
    throw err;
  }
}

// --- Get Top N Scores ---
export async function getTopN(limit = 10) {
  try {
    const { data, error } = await supabase.functions.invoke("get-top-n", {
      method: "GET",
      headers: { "x-submit-secret": "SHARED_SECRET" },
      query: { n: limit },
    });
    console.log("Top N data:", data);
    if (error) throw error;
    return data.recent || [];
  } catch (err) {
    console.error("❌ Error fetching top scores:", err.message);
    throw err;
  }
}

// --- Get Recent N Scores ---
export async function getRecentN(limit = 10) {
  try {
    const { data, error } = await supabase.functions.invoke("get-recent-n", {
      method: "GET",
      headers: { "x-submit-secret": "SHARED_SECRET" },
      query: { n: limit },
    });
    console.log("Recent N data:", data);
    if (error) throw error;
    return data.recent || [];
  } catch (err) {
    console.error("❌ Error fetching recent scores:", err.message);
    throw err;
  }
}
